import { FieldValues, FieldPath } from "react-hook-form"
import { InputField } from "../InputField"
import type { ZipCodeFieldProps } from "./ZipCodeField.types"

/**
 * ZipCodeField wraps InputField with autoComplete="postal-code" so
 * postal/zip codes correctly auto-populate via browser autofill.
 * Stays generic text (not numeric-only) to support international
 * postal codes (e.g. Canadian postal codes contain letters).
 */
export function ZipCodeField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder = "Zip code",
  disabled,
  size,
  variant,
  allowClear,
  maxLength,
}: ZipCodeFieldProps<TFieldValues, TName>) {
  return (
    <InputField
      name={name}
      control={control}
      label={label}
      required={required}
      help={help}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      variant={variant}
      allowClear={allowClear}
      maxLength={maxLength}
      type="text"
      autoComplete="postal-code"
    />
  )
}
